import {ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {checklistItems, pointsCreatedWebsite} from '../moveTo10WebcontentData';
import * as fromStore from "../../../../store";
import {filter, first, switchMap} from "rxjs/operators";
import {Store} from "@ngrx/store";
import { Subject } from 'rxjs';

@Component({
    selector: 'db-move-to10web-hosted',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './move-to10web-hosted.component.html',
    styleUrls: ['./move-to10web-hosted.component.scss'],
    standalone: false
})
export class MoveTo10webHostedComponent implements OnInit, OnDestroy {

  @Input() public desktopScore: number;
  @Input() public domains: any;
  @Input() public manualOptimize: boolean;
  @Input() public websiteId: number;
  @Input() public isTrial: boolean;
  @Input() public isMobile: boolean;
  @Input() public isMigrated: boolean;
  @Input() public activeOptimizer: boolean;

  public checklistItems = checklistItems;
  public pointsCreatedWebsite = pointsCreatedWebsite;
  public managerLink: string = '';
  private _destroyStream$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private _store: Store<fromStore.DbStoreState>
  ) {
  }

  ngOnInit() {
    this._store.select(fromStore.getTenWebProductsLoaded)
      .pipe(
        filter((loaded: boolean) => loaded),
        switchMap(() => this._store.select(fromStore.getTenWebManagerPlugin)),
        first()
      )
      .subscribe(managerPlugin => {
      this.managerLink = managerPlugin && managerPlugin.downloadLink;
    });
  }

  ngOnDestroy() {
    this._destroyStream$.next(true);
    this._destroyStream$.complete();
  }
}
